import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  alt: 'Item Management',
  description:
    'Manage your item library to streamline invoice creation and simplify costing.',
  ctaPrimaryText: 'Add Item',
  ctaSecondaryText: 'Import Items',
  item1: 'Categorise, edit, and delete items',
  item2: 'Add items to Zeller Invoices for faster creation',
  item3: 'Add pricing and descriptions',
  title: 'Create and manage items in one location.',
})
